export enum LoginMethod {
    Email = 1,
    Facebook = 2,
    LinkedIn = 3,
    Google = 4,
    Apple = 5
}

export enum RaffleStatus {
    Draft = 1,
    Active = 2,
    Pending = 3,
    Drawn = 4,
    Deleted = 5
}

export enum RaffleDrawType {
    Manual = 1,
    Digital = 2,
    Other = 3
}

export enum TicketStatus {
    Generated = 1,
    Drawn = 2,
    Void = 3
}

export enum PurchaseStatus {
    Started = 1,
    Completed = 2,
    Refunded = 3,
    Cancelled = 4
}

export enum PrizeStatus {
    Pending = 1,
    Won = 2,
    Void = 3
}

export enum PrizeType {
    Cash = 1,
    Material = 2,
    FiftyFifty = 3
}

export enum RaffleAccessLevel {
    SuperAdmin = 50,
    RaffleCreator = 40,
    RaffleAdmin = 30
}

export enum PaymentMethod {
    Stripe = 1,
    Cash = 2,
    Cheque = 3,
    CreditCard = 4,
    Other = 5
}

export enum RaffleType {
    FiftyFifty = 1,
    Cash = 2,
    Prize = 3
}